import React from 'react';

import springboard from 'springboard';

declare module 'springboard/module_registry/module_registry' {
    interface AllModules {
        Navigation: NavigationModuleReturnValue;
    }
}

type ReloadPageReason =
    | 'logging_out'
    | 'desktop_local_dev_auth_complete'
    | 'desktop_auth_complete'
    | 'rn_auth_token_change'

type SetPathNameReason =
    | 'redirect_to_stored_invite_link_on_signup_success'
    | 'redirect_to_main_due_to_fetch_me_failed_on_init'
    | 'redirect_to_main_due_to_logging_out_in_offline_mode'
    | 'navigate_to_guitar_tuner_from_settings'

type NavigateToPathForReasonReason =
    | 'navigate_to_qrcode_invite_page_from_invite_modal'
    | 'navigate_to_file_page_from_share_intent_success'
    | 'navigate_to_project_page_from_search_bar'
    | 'navigate_to_project_page_from_local_desktop_files_table'
    | 'auto_redirect_to_main_from_root'
    | 'navigate_to_dashboard_from_main_in_login_flow'
    | 'auto_redirect_to_main_from_create_user'
    | 'navigate_to_create_workspace_from_signup_success'
    | 'navigate_to_dashboard_from_breadcrumbs'
    | 'navigate_to_dynamic_path_from_breadcrumbs'
    | 'navigate_to_project_page_from_sidebar_create_project_success'
    | 'navigate_to_dynamic_path_from_sidebar'
    | 'navigate_from_spa_navigate_call'
    | 'navigate_to_projects_page_from_workspace_selector'
    | 'navigate_to_file_page_from_upload_file_modal'
    | 'navigate_to_project_page_from_upload_file_modal'
    | 'navigate_to_project_page_from_project_selection_page'
    | 'navigate_to_file_page_from_project_view_page'
    | 'navigate_to_project_page_from_project_view_page'
    | 'navigate_to_projects_page_from_workspace_selection_page'
    | 'navigate_to_file_page_from_recent_activity'
    | 'navigate_to_dashboard_from_continue_as_offline'
    | 'navigate_to_project_from_new_dashboard'
    | 'navigate_to_all_workspaces_from_new_dashboard'
    | 'navigate_to_file_from_new_dashboard'
    | 'mobile_nav_home'
    | 'mobile_nav_workspaces'
    | 'navigate_to_project_from_mobile_search'
    | 'navigate_to_dashboard_from_header_logo'
    | 'navigate_to_project_from_file_breadcrumb'
    | 'navigate_to_project_from_file_header'
    | 'navigate_to_file_from_full_player'
    | 'navigate_to_workspaces_from_project_selection_page'
    | 'navigate_to_parent_project_from_project_view_page'
    | 'navigate_to_workspace_from_project_view_page'
    | 'navigate_to_trimmed_file'
    | 'mention_project_link'
    | 'mention_view_profile'
    | 'user_popover_view_profile'
    | 'navigate_from_user_profile_to_home'

type NavigationModuleReturnValue = {
    reloadPageForReason: (reason: ReloadPageReason) => void;
    setPathnameForReason: (reason: SetPathNameReason, pathname: string) => void;
    setHashForReason: (reason: SetPathNameReason, hash: string) => void;
    navigateToPathForReason: (navigate: (pathname: string) => void, reason: NavigateToPathForReasonReason, pathname: string) => void;
};

springboard.registerModule('Navigation', {}, async (moduleAPI): Promise<NavigationModuleReturnValue> => {
    return {
        reloadPageForReason,
        setPathnameForReason,
        setHashForReason,
        navigateToPathForReason,
    };
});

const shouldLogNavigationChanges = process.env.NODE_ENV === 'development';

export const reloadPageForReason = (reason: ReloadPageReason) => {
    if (shouldLogNavigationChanges) {
        console.log(`Reloading page due to ${reason}`);
    }
    window.location.reload();
}

export const setPathnameForReason = (reason: SetPathNameReason, pathname: string) => {
    if (shouldLogNavigationChanges) {
        console.log(`Setting path name due to ${reason}`);
    }
    window.location.pathname = pathname;
}

export const setHashForReason = (reason: SetPathNameReason, hash: string) => {
    if (shouldLogNavigationChanges) {
        console.log(`Setting hash due to ${reason}`);
    }
    window.location.hash = hash;
}

export const navigateToPathForReason = (navigate: (pathname: string) => void, reason: NavigateToPathForReasonReason, pathname: string) => {
    if (shouldLogNavigationChanges) {
        console.log(`Navigating to path due to ${reason}`);
    }
    navigate(pathname);
};
